import { defineStore } from 'pinia';
import type { Category } from '@/entities/categories/model/types/categories';

export const useCategoriesStore = defineStore('categories', () => {
  const { $categoriesService } = useNuxtApp();

  const categories: Ref<Category[]> = ref([]);

  const parentCategories = computed(() =>
    categories.value.filter(category => !category.parent)
  );

  const getAllCategories = async (): Promise<void> => {
    try {
      const { data } = await $categoriesService.getCategories();
      if (data) {
        categories.value = data;
      }
    } catch (error) {
      console.error('Ошибка при получении категорий:', error);
    }
  };

  return {
    categories,
    parentCategories,
    getAllCategories,
  };
});
